module.exports = __webpack_public_path__ + "img/horizontal_4_7_7016.05a5c5ca.png";